import { t } from '@lingui/macro';
import { useMap } from '@vis.gl/react-google-maps';

import Minus from '@rover/icons/svg/minus.svg';
import Plus from '@rover/icons/svg/plus.svg';
import { Button, Flex } from '@rover/kibble/core';

export default function ZoomControls(): JSX.Element | null {
  const newMap = useMap();
  const zoom = newMap?.getZoom();

  if (!newMap) return null;

  const zoomIn = (): void => {
    newMap.setZoom((newMap.getZoom() || 0) + 1);
  };

  const zoomOut = (): void => {
    newMap.setZoom((newMap.getZoom() || 0) - 1);
  };

  return (
    <Flex flexDirection="column">
      <Button
        size="small"
        icon={Plus}
        onPress={zoomIn}
        circular
        aria-label={t`Zoom in`}
        mb="3x"
        // @ts-expect-error
        disabled={!!zoom && zoom >= newMap.maxZoom}
      />
      <Button
        size="small"
        icon={Minus}
        onPress={zoomOut}
        circular
        aria-label={t`Zoom out`}
        // @ts-expect-error
        disabled={!!zoom && zoom <= newMap.minZoom}
      />
    </Flex>
  );
}
